import React, {useEffect} from "react"
import "@mixmaxhq/sdk/dist/widgets.css"

import { widgets } from '@mixmaxhq/sdk';
// const mixmax = () => {
//                        const script = document.createElement("script")

//                        script.src =
//                          "https://sdk.mixmax.com/v2.0.0/widgets.umd.min.js"

//                        document.body.appendChild(script)
// 											 console.log("HERE")
// 											 Mixmax.widgets.load()
//                      }

const Calendar = () => {
  useEffect(() => {}, [])
  return (
    <iframe
      frameBorder="0"
      style={{width: "100%", height: "580px"}}
      src="https://cal.mixmax.com/voxology/speak-with-a-voxologist"
    ></iframe>
  )
}

export default Calendar
